<template>
  <modal :value="show" persistent max-width="600">
    <template #title>You have unsaved tags</template>
    <template #content>
      You have unsaved tags. If you continue to vote on this reference
      without clicking 'done', the changes will be lost. Press
      <strong>Cancel</strong>
      below to go back and save your tags, or press
      <strong>Ignore</strong>
      to continue without saving your tags.
    </template>
    <template #actions>
      <action-button class="mr-2" @click="$emit('cancel')">
        Cancel
      </action-button>
      <action-button color="error" @click="$emit('ignore')">
        Ignore
      </action-button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Common/Modal';
import ActionButton from '@/components/Common/ActionButton';

export default {
  name: 'UnsavedTagModal',
  components: {
    Modal,
    ActionButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['cancel', 'ignore'],
};
</script>
